import api from "@/aygulyazilim/libs/axios"
import moment from "moment"
import { defineStore } from "pinia"
import { toast } from "vue3-toastify"
import "vue3-toastify/dist/index.css"

import { useAuthStore } from "./useAuth"

const secretKeyBase = import.meta.env.VITE_APP_secretKey
const version = import.meta.env.VITE_APP_VERSION

export const useHelpersStore = defineStore("helpers", {
  state: () => {
    
    return {
      message: null,
      errors: {},
      version: version,
      config: {
        firma_adi: "",
      },
      ilList: [],
      items: [],
      activeOptions: [
        { label: "Hepsi", value: -1 },
        { label: "Aktif", value: 1 },
        { label: "Pasif", value: 0 },
      ],
      yemekKartiTipi: [
        { label: "yemekKartiTipi.Yok", value: 0 },
        { label: "yemekKartiTipi.Mobil", value: 1 },
        { label: "yemekKartiTipi.Fiziksel", value: 2 },
      ],
      envanterStatusList: [
        { label: "Yeni", value: "Yeni" },
        { label: "Aktif", value: "Aktif" },
        { label: "Zimmet", value: "Zimmet" },
        { label: "Tamirde", value: "Tamirde" },
        { label: "Depoda", value: "Depoda" },
        { label: "Demirbaş", value: "Demirbaş" },
        { label: "Kayıp", value: "Kayıp" },
        { label: "Pasif", value: "Pasif" },
        { label: "Satıldı", value: "Satıldı" },
        { label: "Hurda", value: "Hurda" },
        { label: "Diğer", value: "Diğer" },
      ],
      menus: [],
      shortcuts: [],
      licenses: [],
      allModules: [],
    }
  },
  getters: {
    activeOptionsTranslated: state => {
      return state.activeOptions.map(opt => ({
        ...opt,
      }))
    },
    resolveActiveVariant: state => {
      return active => {
        if (active === 1) return { color: "primary", text: "Aktif" }
        if (active === true) return { color: "primary", text: "Aktif" }
        else return { color: "error", text: "Pasif" }
      }
    },
    resolveEvetVariant: state => {
      return active => {
        if (active === 1) return { color: "primary", text: "Evet" }
        if (active === true) return { color: "primary", text: "Evet" }
        else return { color: "error", text: "Hayır" }
      }
    },
    getDeger: state => {
      return (value, tip = 0) => {
        const item = state.items.find(item => item.name === value)
        if (tip == 1) return item?.deger == 1 ? true : false

        return item ? item.deger : ""
      }
    },
  },
  actions: {
    async fetchMenu() {
      try {
        await this.fetchLicenses()

        const res = await api.get("menu")
        if (res && res.data) {
          const processMenu = items => {
            return items.map(item => {
              const newItem = { ...item }

              if (!newItem.yetki) newItem.yetki = { k: [] }
              if (!newItem.yetki.k) newItem.yetki.k = []

              if (newItem.children) {
                if (newItem.children.length === 0) {
                  delete newItem.children
                } else {
                  newItem.children = processMenu(newItem.children)

                  newItem.children.forEach(child => {
                    if (child.yetki && child.yetki.k) {
                      child.yetki.k.forEach(code => {
                        if (!newItem.yetki.k.includes(code)) {
                          newItem.yetki.k.push(code)
                        }
                      })
                    }
                  })
                }
              }

              return newItem
            })
          }

          this.menus = processMenu(res.data)

          this.fetchShortcuts()
        }
      } catch (error) {
        console.error("Error fetching menu:", error)
      }
    },
    async fetchLicenses() {
      try {
        const res = await api.get("menu/licenses")
        if (res && res.data) {
          this.licenses = res.data.aktif || []
          this.allModules = res.data.tum || []
        }
      } catch (error) {
        console.error("Error fetching licenses:", error)
      }
    },
    navMenu() {
      const tempData = []
      const source = this.menus

      for (let index = 0; index < source.length; index++) {
        if (source[index].yetki !== undefined && source[index].yetki !== null) {
          if (this.yetkiKontrol(source[index].yetki)) {
            if (source[index].children !== undefined && source[index].children.length > 0) {
              const child = []
              for (let i = 0; i < source[index].children.length; i++) {
                if (!source[index].children[i].yetki || this.yetkiKontrol(source[index].children[i].yetki)) {
                  child.push(source[index].children[i])
                }
              }

              const newItem = { ...source[index], children: child }

              tempData.push(newItem)
            } else {
              tempData.push(source[index])
            }
          }
        } else {
          if (source[index].children !== undefined && source[index].children.length > 0) {
            const child = []
            for (let i = 0; i < source[index].children.length; i++) {
              if (!source[index].children[i].yetki || this.yetkiKontrol(source[index].children[i].yetki)) {
                child.push(source[index].children[i])
              }
            }
            const newItem = { ...source[index], children: child }

            tempData.push(newItem)
          } else {
            tempData.push(source[index])
          }
        }
      }

      return tempData
    },
    yetkiKontrol({ k = [], a = false, p = false, m = null } = {}) {
      const authStore = useAuthStore()
      const user = authStore?.user

      if (!user) return false

      // Lisans kontrolü
      if (m && this.allModules.includes(m)) {
        if (!this.licenses.includes(m)) return false
      }

      if (k.length === 0 && a === false && p === false) return true
      if (p && user.programci) return true
      if (a && (user.programci || user.admin)) return true
      for (let i = 0; i < k.length; i++) {
        if (user.programci || user.admin) return true
        const s = user.yetkiler?.filter(x => x.kod === k[i])
        if (s && s.length > 0) return true
      }

      return false
    },
    async fetchConfig() {
      try {
        this.items = []

        const res = await api.get("config")
        if (res != undefined) {
          this.items = res?.data
          for (let i = 0; i < this.items.length; i++) {
            this.config[this.items[i].name] = this.getDeger(this.items[i].name)
          }
        }
      } catch (error) {
        console.error("Error loading config:", error)
      }
    },
    async toast(status, message) {
      switch (status) {
      case "success":
        toast.success(message, {
          theme: "auto",
          autoClose: 5000,
          dangerouslyHTMLString: true,
        })
        break
      case "error":
        toast.error(message, {
          theme: "auto",
          autoClose: 5000,
          dangerouslyHTMLString: true,
        })
        break
      case "danger":
      case "warn":
      case "warning":
        toast.warning(message, {
          theme: "auto",
          autoClose: 5000,
          dangerouslyHTMLString: true,
        })
        break
      case "info":
        toast.info(message, {
          theme: "auto",
          autoClose: 5000,
          dangerouslyHTMLString: true,
        })
        break
      default:
        toast(message, {
          theme: "auto",
          type: "default",
          autoClose: 5000,
          dangerouslyHTMLString: true,
        })
      }
    },
    async listIl() {
      const res = await api.get("il")
      if (res != undefined) {
        this.ilList = res?.data || []
      }
    },
    async copyHafiza(mytext) {
      try {
        await navigator.clipboard.writeText(mytext)
        alert("Copied")
      } catch ($e) {
        alert("Cannot copy")
      }
    },
    encryptData(data) {
      const tarih = moment().format("YYYYMMDD")
      const secretKey = `${secretKeyBase}${tarih}`
      const dataString = JSON.stringify(data)

      return CryptoJS.AES.encrypt(
        dataString,
        secretKey,
      ).toString()
    },
    async downloadFile(blob, fileName) {
      if (window.showSaveFilePicker) {
        try {
          const handle = await window.showSaveFilePicker({
            suggestedName: fileName,
            types: [{
              description: 'Excel Dosyası',
              accept: { 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] },
            }],
          })

          const writable = await handle.createWritable()

          await writable.write(blob)
          await writable.close()

          return
        } catch (err) {
          console.warn("SaveFilePicker cancelled or failed, falling back:", err)

          if (err.name === 'AbortError') return
        }
      }

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)

        return
      }

      const reader = new FileReader()

      reader.onload = function () {
        const url = reader.result
        const a = document.createElement('a')

        a.style.display = 'none'
        a.href = url
        a.setAttribute("download", fileName)
        a.download = fileName

        document.body.appendChild(a)
        a.click()

        setTimeout(() => {
          document.body.removeChild(a)
        }, 100)
      }
      reader.readAsDataURL(blob)
    },

    // Shortcuts Actions
    async fetchShortcuts() {
      try {
        const res = await api.get("shortcuts")
        if (res && res.data) {
          this.shortcuts = res.data
        }
      } catch (error) {
        console.error("Error fetching shortcuts:", error)
      }
    },
    async addShortcut(payload) {
      try {
        const res = await api.post("shortcuts", payload)
        if (res && res.data) {
          this.shortcuts.push(res.data)
          this.toast("success", "Kısayol eklendi")
        }
      } catch (error) {
        if (error.response && error.response.status === 409) {
          this.toast("warning", "Bu kısayol zaten ekli")
        } else {
          this.toast("error", "Kısayol eklenirken hata oluştu")
          console.error(error)
        }
      }
    },
    async removeShortcut(uuid) {
      try {
        await api.delete(`shortcuts/${uuid}`)
        this.shortcuts = this.shortcuts.filter(s => s.uuid !== uuid)
        this.toast("info", "Kısayol silindi")
      } catch (error) {
        this.toast("error", "Silme işlemi başarısız")
        console.error(error)
      }
    },
  },
})
